import { axios } from "./axios";
import { CONTACT_US_QUERY } from "../constants/paths";

/**
 * contactUsQuery DTO
 * @export
 * @typedef {contactUsQueryDTO}
 */

export type contactUsQueryDTO = {
  name: String;
  email: String;
  subject: String;
  description: String;
};

/**
 * inspection Request API Call
 * @param {contactUsQueryDTO} data
 * @returns {Promise<any>}
 */
export const contactUsQuery = (data: contactUsQueryDTO): Promise<any> => {
  return axios.post(CONTACT_US_QUERY, data);
};
